exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".block.new{border-style:dashed;height:1.5rem;width:1.5rem}.block.new.quota{height:1rem;width:1rem}.block.new.quotaMet{border-color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5d850d66!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/NewBlock.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5d850d66!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/NewBlock.vue
// module chunks = 0